import * as React from 'react';

const ListPageBody: React.FC = ({ children }) => {
  return <div className="co-m-pane__body co-m-pane__body--no-top-margin">{children}</div>;
};

export default ListPageBody;
